import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 min-w-0" }
const _hoisted_2 = { class: "text-sm truncate" }
const _hoisted_3 = { class: "text-xs whitespace-pre-wrap" }
const _hoisted_4 = { class: "flex items-center gap-1 mt-0.5" }

import { computed } from 'vue'
import {
  FileText,
  Paperclip,
  Monitor,
  ListTodo,
  CalendarDays,
  Loader2,
  Download,
  Check,
} from 'lucide-vue-next'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import type { CopilotContextItem } from '@/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContextTreeItem',
  props: {
    item: {},
    selected: { type: Boolean },
    isExtracting: { type: Boolean }
  },
  emits: ["toggle", "extract"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const icon = computed(() => {
  switch (props.item.type) {
    case 'document': return FileText
    case 'attachment': return Paperclip
    case 'application': return Monitor
    case 'requirement': return ListTodo
    case 'meeting': return CalendarDays
    default: return FileText
  }
})

const hasContent = computed(() => !!props.item.content)

const isAttachment = computed(() => props.item.type === 'attachment')

const contentPreview = computed(() => {
  if (!props.item.content) return 'Sin contenido extraido'
  return props.item.content.substring(0, 200) + (props.item.content.length > 200 ? '...' : '')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-start gap-2 py-1.5 px-2 rounded-md hover:bg-muted/50 cursor-pointer group",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('toggle', __props.item.id)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["mt-0.5 shrink-0 h-4 w-4 rounded-sm border shadow grid place-content-center transition-colors", __props.selected ? 'bg-primary border-primary text-primary-foreground' : 'border-primary'])
    }, [
      (__props.selected)
        ? (_openBlock(), _createBlock(_unref(Check), {
            key: 0,
            class: "h-3 w-3"
          }))
        : _createCommentVNode("", true)
    ], 2),
    (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), { class: "h-4 w-4 mt-0.5 shrink-0 text-muted-foreground" })),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(TooltipProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), null, {
            default: _withCtx(() => [
              _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(__props.item.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(TooltipContent), {
                side: "right",
                class: "max-w-[300px]"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(contentPreview.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        (__props.item.entityType)
          ? (_openBlock(), _createBlock(_unref(Badge), {
              key: 0,
              variant: "secondary",
              class: "text-[10px] px-1 py-0 h-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.item.entityType), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isAttachment.value)
          ? (_openBlock(), _createBlock(_unref(Badge), {
              key: 1,
              variant: hasContent.value ? 'default' : 'outline',
              class: "text-[10px] px-1 py-0 h-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(hasContent.value ? 'extraido' : 'pendiente'), 1)
              ]),
              _: 1
            }, 8, ["variant"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (isAttachment.value && !hasContent.value)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          variant: "ghost",
          size: "icon",
          class: "h-6 w-6 shrink-0 opacity-0 group-hover:opacity-100",
          disabled: __props.isExtracting,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('extract', __props.item.id)), ["stop"]))
        }, {
          default: _withCtx(() => [
            (__props.isExtracting)
              ? (_openBlock(), _createBlock(_unref(Loader2), {
                  key: 0,
                  class: "h-3 w-3 animate-spin"
                }))
              : (_openBlock(), _createBlock(_unref(Download), {
                  key: 1,
                  class: "h-3 w-3"
                }))
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})